import React from 'react';
import { Sun, Moon } from 'lucide-react'; // Keep this import
import { useTheme } from '../../contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <button
      onClick={toggleTheme}
      className="relative p-2 rounded-lg transition-all duration-300 ease-in-out {/* Keep this style */}
        bg-modular-canvas-fog hover:bg-modular-champagne-dust dark:bg-dark-card dark:hover:bg-dark-border
        text-modular-frosted-indigo hover:text-modular-desert-mauve dark:text-modular-frosted-indigo dark:hover:text-modular-desert-mauve
        border border-modular-stone-alloy dark:border-modular-stone-alloy
        hover:shadow-modular-glow dark:hover:shadow-dark-fire
        focus:outline-none focus:ring-2 focus:ring-modular-frosted-indigo focus:ring-offset-2 
        dark:focus:ring-modular-frosted-indigo dark:focus:ring-offset-dark-bg
        transform hover:scale-105 active:scale-95"
      title={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
    >
      <div className="relative w-5 h-5">
        <Sun 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 transform
            ${theme === 'light' 
              ? 'rotate-0 scale-100 opacity-100' 
              : 'rotate-90 scale-0 opacity-0'
            }`}
        />
        <Moon 
          className={`absolute inset-0 w-5 h-5 transition-all duration-300 transform
            ${theme === 'dark' 
              ? 'rotate-0 scale-100 opacity-100' 
              : '-rotate-90 scale-0 opacity-0'
            }`}
        />
      </div>
    </button>
  );
};